import styled from "styled-components";
import FilterInput from "../input/FilterInput";

const FilterList = [
  { id: 1, value: "Front-End Developer" },
  { id: 2, value: "Back-End Developer" },
  { id: 3, value: "Full-Stack Developer" },
];

const ResetFilterButton = styled.div`
  width: 210px;
  font-size: 16px;
  padding: 10px 24px;
  @media (max-width: 768px) {
    width: 100%;
  }
`;
const GalleryFilter = ({ handleToggle, resetFilter, checkList }) => {
  return (
    <div>
      {FilterList.map((filter) => (
        <FilterInput
          filter={filter}
          key={filter.id}
          handleToggle={handleToggle}
          checkList={checkList}
        />
      ))}
      <ResetFilterButton className="button w-button" onClick={resetFilter}>
        FİLTRELERİ TEMİZLE
      </ResetFilterButton>
    </div>
  );
};

export default GalleryFilter;
